const QUOTE_DATA = [
  {
    text: 'הצלחה היא היכולת לעבור מכישלון לכישלון מבלי לאבד את ההתלהבות',
    author: "וינסטון צ'רצ'יל"
  },
  {
    text: "אני אסיר תודה לכל מי שאמר לי 'לא' – הם הסיבה שעשיתי זאת בעצמי",
    author: "אלברט אינשטיין"
  },
  {
    text: "על מנת להצליח, הרצון שלך להצלחה צריך להיות גדול יותר מהפחד שלך מהכישלון",
    author: "ביל קוסבי"
  },
  {
    text: "תן לי 6 שעות להוריד עץ ואני אבלה את 4 הראשונות בלחדד את הגרזן",
    author: "אברהם לינקולן"
  },
  {
    text: "הקושי הגדול הוא לא לפתח רעיונות חדשים, אלא לזנוח את הישנים",
    author: "ג'ון מינרד"
  },
  {
    text: "כשהם אומרים לך שאתה לא יכול, הם מראים לך את הגבולות שלהם, לא שלך",
    author: "קווין קינו"
  },
  {
    text: "אל תתן למה שאתה לא יכול לעשות להפריע למה שאתה כן יכול לעשות",
    author: "ג'ון רוברט וודן"
  },
  {
    text: "רק מי שלוקח סיכון והולך רחוק, מגלה עד כמה רחוק הוא יכול להגיע",
    author: "אלברט איינשטיין"
  },
  {
    text: "אנשים אומרים שמוטיבציה לא מחזיקה הרבה זמן. טוב, גם מקלחת לא, לכן אנו ממליצים אותה על בסיס יומי",
    author: "זיג זיגלר"
  },
  {
    text: "זה לא משנה כמה לאט אתה הולך, כל עוד אתה לא עוצר",
    author: "קונפציוס"
  },
  {
    text: "העבר שלך לא קובע את העתיד שלך. רק הבחירות שלך",
    author: "אנתוני רובינס"
  },
  {
    text: "המקום היחידי שבו הצלחה מופיעה לפני עבודה הוא המילון",
    author: "וינס לומברדי"
  },
  {
    text: "הצלחה מורכבת מאחוז אחד של השראה ו-99 אחוזים של הזעה",
    author: "תומס אלווה אדיסון"
  },
  {
    text: "כשמישהו אומר לך לא, זה לא אומר שאי אפשר לעשות זאת, זה רק אומר לא לעשות את זה איתו",
    author: "קרן מילר"
  },
  {
    text: "כנראה לא הייתם מודאגים כל כך ממה אנשים חושבים עליכם, אילו הייתם יודעים כמה הם עושים זאת לעיתים רחוקות",
    author: "לא ידוע"
  },
  {
    text: "התהילה הגדולה ביותר שלנו אינה בלעולם לא ליפול, אלא בלקום בכל פעם שאנו נופלים",
    author: "קונפוציוס"
  },
  {
    text: "אתה לא אוהב את הדברים איך שהם? שנה את זה  אתה לא עץ",
    author: "ג'ים רון"
  },
  {
    text: "החיים הם כמו רכיבה על אופניים, בשביל לשמור על איזון אתה חייב להמשיך להתקדם.",
    author: "אלברט איינשטיין"
  },
  {
    text: "השאיפה למושלמות היא סירוב עצמי להתקדם",
    author: "ג'וליה קמרון"
  },
  {
    text: "הפסימי מתלונן על הרוח, האופטימי מצפה שהיא תשתנה, החכם מכוון את המפרש בהתאם",
    author: "וויליאם ארתור וורד"
  },
  {
    text: "מכשולים הם הדברים המפחידים שאתה רואה כשאתה מוריד את העיניים מהמטרה שלך",
    author: "הנרי פורד"
  },
  {
    text: "כולם רוצים להיות על ראש ההר, אבל כל הכיף והסיפוק מגיע דווקא מלטפס עליו",
    author: "אנדי רוני"
  },
  {
    text: "עדיף להישאר בשקט ולהיחשב כטיפש, מאשר לדבר ולהסיר כל ספק",
    author: "אברהם לינקולן"
  },
  {
    text: "אומץ הוא הקסם שהופך חלומות למציאות",
    author: "ריכטר אבנד"
  },
  {
    text: "אין סודות בהצלחה. זאת התוצאה של הכנה, עבודה קשה ולמידה מטעויות",
    author: "קולין פאוול"
  },
  {
    text: "הדבר היחיד שעומד בינך לבין המטרה שלך הוא הסיפור הזה שאתה ממשיך לספר לעצמך על למה אתה לא יכול לעשות את זה",
    author: "ג’ורדן בלפורט"
  },
  {
    text: "רק כאשר חשוך מספיק, יכול אדם לראות את הכוכבים.",
    author: "מרטין לותר קינג"
  },
  {
    text: "יש רק דרך אחת להימנע מביקורת: אל תעשה כלום, אל תגיד כלום ואל תהיה כלום",
    author: "אריסטו"
  },
  {
    text: "תהיה עצמך, כל שאר האנשים כבר תפוסים",
    author: "לא"
  },
  {
    text: "אני איש זקן, היו לי צרות רבות בחיי, אבל רובן לא קרו באמת.",
    author: "מארק טוויין"
  },  
  {
    text: "אל תלכו להיכן שהדרך מובילה. לכו היכן שאין דרך, ותשאירו עקבות",
    author: "ראלף וולדו אמרסון"
  }
]

export default QUOTE_DATA;